module.exports = __webpack_public_path__ + "media/images/subject_img/BIOMEDICAL SCIENCES-19d3555da29368e8b920c47c6b3a2604.jpg";